import { render, staticRenderFns } from "./DeclarationForm.vue?vue&type=template&id=06b1ffa0"
import script from "./DeclarationForm.vue?vue&type=script&lang=js"
export * from "./DeclarationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports